import { render, staticRenderFns } from "./ChangeOrderFilters.vue?vue&type=template&id=bf7bba06&"
import script from "./ChangeOrderFilters.vue?vue&type=script&lang=ts&"
export * from "./ChangeOrderFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports